import { CSSProperties } from 'react'

export const popupInitialState = {
    showCancelPopup: false,
    tranzilaApproval: true,
    eventInitiator: 'REGULAR_CANCELLATION',
    recoverSubscriptionId: null,
    cancellationProcess: { failed: false, success: false, process: false, step: 0, awaitingStepsCount: 2, errorMsg: '' }
}

export const styles: {
    flex_row: CSSProperties
    flex_col: CSSProperties
    check_circle: CSSProperties
    close_circle: CSSProperties
    title: CSSProperties
    xBtn: CSSProperties
    footerText: CSSProperties
    preBtn: CSSProperties
    mainErr: CSSProperties
} = {
    flex_row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        gap: '10px'
    },
    flex_col: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        gap: '10px'
    },
    check_circle: { color: '#52c41a', fontSize: 18, display: 'contents' },
    close_circle: { color: '#ff4d4f', fontSize: 18, display: 'contents' },
    title: { fontSize: 18, fontWeight: 500 },
    xBtn: { fontSize: 24, lineHeight: 1 },
    footerText: { fontSize: 16, fontWeight: 500, color: '#52c41a', textAlign: 'center', width: '100%' },
    preBtn: { margin: '0 auto', lineHeight: '10px' },
    mainErr: { position: 'absolute', left: '-80px', color: 'red' }
}

export const texts = {
    main_pre: 'תהליך ביטול מינוי',
    main_pre_block: 'תהליך חסימת מינוי',
    main_pre_block_on: 'תהליך חסימת מינוי מתבצע כעת, אנא אל תעזבו את העמוד עד לסיום התהליך...',
    main_pre_active: 'תהליך הפלת מינוי',
    main_pre_active_on: 'תהליך הפלת מינוי מתבצע כעת, אנא אל תעזבו את העמוד עד לסיום התהליך...',

    main: 'תהליך ביטול מינוי מתבצע כעת, אנא אל תעזבו את העמוד עד לסיום התהליך...',
    process_1_pre: 'ביטול מינוי במערכת',
    process_3_pre: 'חסימת מינוי במערכת',
    process_4_pre: 'הפעלת מינוי במערכת',
    process_5_pre: 'הפעלת הוראת קבע',
    process_2_pre: 'ביטול הוראת קבע',
    process_1: 'ביטול מינוי במערכת',
    process_2: 'ביטול הוראת קבע',
    process_done: 'התהליך הושלם בהצלחה ✅ ' + 'ניתן לסגור את החלון',
    btn_title: 'הפעלת תהליך',
    error_main: '❌ תהליך נכשל',
    error_1: 'אין הו״ק פעילה',
    error_2: 'שימו לב! יש 2 הו״ק פעילות למנוי',
    error_3: 'לא נמצאו פרטים'
}
